import React from 'react';
import { Home, FileText, Image, Globe, Settings, Layout, Calendar, BookOpen, List, Newspaper, Presentation, Library, ClipboardCheck, PenLine, Scale, UsersRound, Landmark, Upload, Send, CalendarClock, UserPlus, BedDouble } from 'lucide-react';
import './Sidebar.css';

const iconMap = {
  'home': Home,
  about: BookOpen,
  news: Newspaper,
  aboutConference: Presentation,
  aboutJournal: Library,
  guidelinesReviewers: ClipboardCheck,
  guidelinesAuthors: PenLine,
  ethics: Scale,
  editorialBoard: UsersRound,
  conferenceMain: Landmark,
  conferencePastNew: CalendarClock,
  conferenceRegister: UserPlus,
  conferenceAccommodation: BedDouble,
  articleSubmission: Upload,
  articleSubmit: Send,
  'about-us': BookOpen,
  'contact': Calendar,
  'seo': Globe,
  'footer': Layout,
  default: FileText
};

const Sidebar = ({ sections, selectedSection, onSelectSection, isOpen }) => {
  const getIcon = (sectionKey) => {
    const Icon = iconMap[sectionKey] || iconMap.default;
    return <Icon size={18} />;
  };

  const getDisplayName = (sectionKey) => {
    return sections[sectionKey]?.name || sectionKey;
  };

  return (
    <aside className={`admin-sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <h2>Секции</h2>
      </div>
      <nav className="sidebar-nav">
        <button
          className={`sidebar-item ${selectedSection === null ? 'active' : ''}`}
          onClick={() => onSelectSection(null)}
        >
          <FileText size={18} />
          <span>Все секции</span>
        </button>
        {Object.entries(sections).map(([key, section]) => (
          <button
            key={key}
            className={`sidebar-item ${selectedSection === key ? 'active' : ''}`}
            onClick={() => onSelectSection(key)}
          >
            {getIcon(key)}
            <span>{getDisplayName(key)}</span>
            <span className="item-count">{section.items.length}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
